export default __webpack_public_path__ + "static/media/arrow-right.fb517e13.svg";